import { Select } from 'antd';
import React from 'react';
import { STATISTICS_APP_TITLE } from '../../config/settings';
import { ClubVm, TeamVm } from '../../utils/api';
import { filterOptionForSearch } from '../../helpers/normalizeForSearch';
import { clubLabel, InsightsClubScope, teamLabel } from './insightsClubScope';

interface Props {
    scope?: InsightsClubScope;
    /** Right-hand slot for page level actions, e.g. a back link. */
    children?: React.ReactNode;
}

/** Brand + club context. Everything below the topbar is about the selected club. */
const InsightsTopbar: React.FC<Props> = ({ scope, children }) => (
    <header className="insightsTopbar">
        <div className="insightsBrand">
            <p className="insightsBrandName">Total Waterpolo</p>
            <p className="insightsBrandTag">{STATISTICS_APP_TITLE}</p>
        </div>

        <div className="insightsScope">
            {scope && (
                <div className="insightsClubPicker">
                    <span className="insightsClubPickerLabel">Club</span>
                    {scope.canSwitchClubs ? (
                        <Select
                            size="small"
                            showSearch
                            filterOption={filterOptionForSearch}
                            optionFilterProp="label"
                            loading={scope.loading}
                            placeholder="Select club"
                            value={scope.selectedClubId}
                            onChange={(value: number) => scope.selectClub(value)}
                            options={scope.clubs.map((club: ClubVm) => ({
                                value: club.id,
                                label: clubLabel(club),
                            }))}
                            style={{ minWidth: 200 }}
                        />
                    ) : (
                        <strong className="insightsClubPickerLocked">
                            {scope.loading ? '...' : clubLabel(scope.selectedClub) || '-'}
                        </strong>
                    )}
                </div>
            )}

            {scope && scope.teams.length > 0 && (
                <div className="insightsClubPicker">
                    <span className="insightsClubPickerLabel">Team</span>
                    <Select
                        size="small"
                        allowClear
                        showSearch
                        filterOption={filterOptionForSearch}
                        optionFilterProp="label"
                        loading={scope.teamsLoading}
                        placeholder="All teams"
                        value={scope.selectedTeamId}
                        onChange={(value?: number) => scope.selectTeam(value)}
                        options={scope.teams.map((team: TeamVm) => ({
                            value: team.id,
                            label: teamLabel(team),
                        }))}
                        style={{ minWidth: 240 }}
                    />
                </div>
            )}

            {children}
        </div>
    </header>
);

export default InsightsTopbar;
